export default __webpack_public_path__ + "static/media/hyperlink.d0b550cf.svg";